import type { SaveStatusLabelLabels, SaveStatusLabelStatus } from "../components/molecules/SaveStatusLabel";

/** Copy for the story's save state, in the top bar and on a tile. */
export const STORY_SAVE_STATUS_LABELS: SaveStatusLabelLabels = {
  saving: "Saving…",
  saved: "Saved",
  error: "Couldn’t save",
  retry: "Retry",
};

/** Chart editor autosave statuses that mean a write is on its way. */
const SAVING_STATUSES = new Set(["waiting", "saving"]);

/**
 * The one save state the top bar shows: an error wins, then anything on its way, else saved.
 * `editorStatus` is the chart editor's autosave status; `tileStatuses` are the tiles' draft statuses;
 * `isWritePending` is any other write in flight (a story filter).
 */
export const toPageSaveStatus = ({
  editorStatus,
  tileStatuses = [],
  isWritePending = false,
}: {
  editorStatus?: string;
  tileStatuses?: ReadonlyArray<string | undefined>;
  isWritePending?: boolean;
}): SaveStatusLabelStatus => {
  if (editorStatus === "error" || tileStatuses.includes("error")) return "error";
  if (isWritePending || (editorStatus && SAVING_STATUSES.has(editorStatus)) || tileStatuses.includes("saving")) {
    return "saving";
  }
  return "saved";
};
